import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-858fff3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tooltip-property" }
const _hoisted_2 = { class: "text-right text-xs" }

import { PropType } from 'vue';
import { VueAttributeClass } from '@/types/attributes-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListItemTooltipProperty',
  props: {
  label: {
    type: String,
    required: true,
  },
  value: {
    type: [String, Number],
    required: true,
  },
  class: {
    type: [String, Object] as PropType<VueAttributeClass>,
    default: 'text-xs leading-5',
  },
},
  setup(__props) {

const props = __props;



const formatItemTooltipPropertyLabel = (label: string): string => {
  return `${label}:`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(formatItemTooltipPropertyLabel(props.label)), 1),
    _createElementVNode("span", {
      class: _normalizeClass(props.class)
    }, _toDisplayString(props.value), 3)
  ]))
}
}

})